<template>
    <b-modal
        id="select-stc-uuid"
        v-model="modal"
        ref="select-stc-uuid"
        size="md"
        :title="$t('slu_dashboard.add_assignments')"
        modal-class="apprentice-default-modal select-slu-stc-uuid-modal"
        :ok-title="$t('common.add')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @ok="onok">
        <b-form-group
            class="open-up-field"
            v-if="this.$authUser.isAdmin()"
            label-for="slu-stc-switch"
            :label="$t('slu_dashboard.open_field')">
            <b-form-checkbox
                class="slu-stc"
                id="slu-stc-switch"
                v-model="openField"
                :disabled="forceOpenField"
                switch>
            </b-form-checkbox>
        </b-form-group>

        <b-form-group
            class="stc-uuid"
            id="stc-uuid-multiselect"
            v-if="openField"
            :label="$t('slu_dashboard.assignment_code')"
            label-for="stc-uuid-input">
            <b-form-input
                id="stc-uuid-input"
                v-model="selectedCode.code"
                :placeholder="$t('slu_dashboard.type_uuid_of_the_course_here')">
            </b-form-input>
        </b-form-group>

        <b-form-group
            class="stc-uuid-multiselect"
            id="stc-uuid-multiselect"
            v-else
            :label="$t('slu_dashboard.assignments')"
            label-for="stc-uuid-multiselect-input">
            <design-2021-apprentice-multiselect-component
                id="stc-uuid=multiselect-input"
                v-model="selectedCode"
                :multiple-select="false"
                :options="testCodes"
                label="name"
                track-by="code">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-slu-som-today-connect-modal-component',
    props: {
        sluCohortIn: Object,
        somTodayTestIn: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            codes: [],
            openField: false,
            forceOpenField: false,
            modal: false,
            selectedCode:
                this.somTodayTestIn !== null
                    ? this.somTodayTestIn
                    : {
                          name: this.$t('slu_dashboard.select_an_assignment'),
                          code: null,
                          $isDisabled: true,
                      },
        };
    },
    computed: {
        testCodes() {
            let assignments = this.codes.map((code) => {
                let description = code.description ? code.description : this.$t('slu_dashboard.no_description');
                return {
                    name: description,
                    code: code.code,
                };
            });

            assignments.unshift({
                name: this.$t('slu_dashboard.select_an_assignment'),
                code: null,
                $isDisabled: true,
            });

            return assignments;
        },
    },
    methods: {
        show() {
            this.axios
                .get(this.routes.sluGetSomTodayConnectTests(this.sluCohortIn.slu_course_id, this.sluCohortIn.id))
                .then(
                    (response) => {
                        this.codes = response.data;
                        this.modal = true;
                    },
                    (error) => {
                        if (this.$authUser.isAdmin()) {
                            this.openField = true;
                            this.forceOpenField = true;
                            this.modal = true;
                        } else {
                            this.alert.ajaxError(error);
                        }
                    },
                );
        },
        onok() {
            this.$emit('updateStcCode', this.selectedCode);
        },
    },
};
</script>

<style scoped lang="scss"></style>
